export const FORM_SUBMISSIONS_LOAD_ERROR = 'Could not load form submissions.';

export const FORM_SUBMISSIONS_ZIP_EXPORT_ERROR =
  'Could not export submissions archive. Check your network connection and try again.';

export const FORM_RESPONSE_PDF_EXPORT_ERROR = 'Could not export form response.';

/**
 * Form Submissions page "Actions" dropdown labels. The page has no row context, so the
 * labels keep the "Form" noun (unlike the All Forms table row actions).
 */
export const FORM_SUBMISSIONS_ACTION_LABELS = Object.freeze({
  PREVIEW: 'Preview Form',
  EDIT: 'Edit Form',
  DISABLE: 'Disable Form',
  ENABLE: 'Enable Form',
});
